import { useIsFocused } from "@react-navigation/native";
import { BlurTargetView, BlurView } from "expo-blur";
import React, { useEffect, useRef, useState } from "react";
import { ImageBackground, StatusBar, StyleSheet, View } from "react-native";

import { useBreakpointValue } from "@whoosh/design-system/src/hooks/useBreakpointValue";
import { images } from "@whoosh/design-system/src/theme/images";

import { AuthenticationModal } from "../AuthenticationModal";

export const AuthenticationModalScreen = ({
  onComplete,
  onCloseHandler,
  clubSlug,
}: {
  onComplete: () => void;
  onCloseHandler: () => void;
  clubSlug: string;
}) => {
  const isMobileLayout = useBreakpointValue({
    base: true,
    lg: false,
  });
  const [isOpen, setIsOpen] = useState(true);
  const isScreenFocused = useIsFocused();
  const blurTargetRef = useRef<View | null>(null);

  /**
   * If we unfocus this screen, then hide the modal
   * otherwise it'll shoot itself all the way to the top no
   * matter where you are
   */
  useEffect(() => {
    setIsOpen(isScreenFocused);
  }, [isScreenFocused]);
  return (
    <>
      <StatusBar
        backgroundColor="transparent"
        translucent
        barStyle="light-content"
      />
      <View style={{ flex: 1 }}>
        <BlurTargetView ref={blurTargetRef} style={{ flex: 1 }}>
          <ImageBackground
            source={
              isMobileLayout
                ? images.initialBackground
                : images.desktopLandingBackground
            }
            resizeMode="cover"
            style={{ flex: 1 }}
          />
        </BlurTargetView>
        <BlurView
          blurMethod="dimezisBlurViewSdk31Plus"
          blurTarget={blurTargetRef}
          intensity={100}
          style={StyleSheet.absoluteFill}
        />
        <AuthenticationModal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            onCloseHandler();
          }}
          onComplete={onComplete}
          clubSlug={clubSlug}
        />
      </View>
    </>
  );
};
